// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/img/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --Fond-clair: '#F9F2F2';
  --main-bg-color: brown;
}

select {
  /* appearance: none; */
  background-color: transparent;
  border: none;
  padding: 1em;
  margin: 0;
  width: 100%;
  font-family: inherit;
  font-size: inherit;
  cursor:auto;
  line-height: inherit;
  
}



.App {
  text-align: center;
}

html, body {
  height: 100svh;
  height: 100vh;
  overflow: hidden;
}

.active {
  color: red;
}

.inactive {
  color: #444;
}

.bg {
  background: var(--Fond-clair, url(${___CSS_LOADER_URL_REPLACEMENT_0___}) lightgray 50% / cover no-repeat, #F9F2F2);
}

.img-crop {
  overflow: hidden;
}

.clickable {
  cursor: pointer;
}

.rotate {
  transform: rotate(180deg);
}

.onHover {
  cursor: pointer;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 6px;
  }
}

.onHoverBorder {
  border: 1px solid #C3645E;
}

.fadeIn {
  animation: 0.5s fadeIn forwards;
  height: -webkit-fill-available;
}

.fadeOut {
  /* animation: 0.0001s fadeOut forwards; */
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.select {
  position: relative;
  overflow: hidden;
  display: block;
  margin: auto;
  width: 330px;
  height: 100%;
  border-bottom: 0px;
  border-radius: 3px;
  font-size: 12px;
  box-shadow: 0px 1em 2em -1.5em rgba(0, 0, 0, .5);
  >i.toggle {
      position: absolute;
      z-index: 4;
      right: 1.5em;
      top: 1.6em;
      color: #ccc
  }
  .title,
  .placeholder {
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
      padding: 1.5em 2em;
      background: rgba(255, 255, 255, 1);
      border-top: 1px solid rgba(0, 0, 0, .05);
      cursor: pointer;
  }
  &>input {
      position: absolute;
      left: 0px;
      top: 0px;
      z-index: 1;
      width: 100%;
      height: 100%;
      display: block;
      opacity: 0;
      cursor: pointer;
      &:checked {
          ~i.toggle.icon-arrow-down {
              display: none;
          }
          ~i.toggle.icon-arrow-up {
              display: block;
          }
          div.options label.option .title {
              display: none!important;
          }
      }
      &:not(:checked) {
          z-index: 4;
          ~label.option {
              >span.title {
                  display: none;
              }
          }
          ~i.toggle.icon-arrow-up {
              display: none;
          }
          ~i.toggle.icon-arrow-down {
              display: block;
          }
      }
      &:disabled {
          cursor: no-drop;
      }
  }
  &>span.placeholder {
      position: relative;
      z-index: 0;
      display: inline-block;
      width: 100%;
      color: #999;
      border-top: 0px;
  }
  label.option {
      display: block;
      overflow: hidden;
      z-index: 1;
      width: 100%;
      transition: all 1s ease-out;
      span.title {
          position: relative;
          z-index: 2;
          transition: background .3s ease-out;
          i.icon {
              padding-right: 8px;
              color: rgba(146, 168, 209, 1);
          }
          &:hover {
              color: #fff;
              background: rgba(255, 255, 255, .3);
              box-shadow: inset 0px 1px 0px rgba(0, 0, 0, .1);
          }
      }
      input {
          display: none;
          &:checked~span.title {
              position: absolute;
              display: block;
              z-index: 3;
              top: 0px;
              font-size: 12px;
              background: #fff;
              border-top: 0px;
              box-shadow: none;
              color: inherit;
              width: 100%;
          }
          &:disabled {
              &~span.title {
                  background: #f9f9f9!important;
                  color: #aaa;
                  &:hover {
                      color: #aaa;
                      background: none;
                      cursor: no-drop;
                  }
              }
          }
      }
  }
}

.select2 {
  position: relative;
  overflow: hidden;
  display: block;
  margin: auto;
  width: 330px;
  height: 100%;
  border-bottom: 0px;
  border-radius: 3px;
  font-size: 12px;
  box-shadow: 0px 1em 2em -1.5em rgba(0, 0, 0, .5);
  i.toggle {
      position: absolute;
      z-index: 4;
      right: 1.5em;
      top: 1.6em;
      color: #ccc
  }
  .title,
  .placeholder {
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
      padding: 1.5em 2em;
      background: rgba(255, 255, 255, 1);
      border-top: 1px solid rgba(0, 0, 0, .05);
      cursor: pointer;
  }
  &>label>input {
      position: absolute;
      left: 0px;
      top: 0px;
      z-index: 2;
      width: 100%;
      height: 100%;
      display: block;
      opacity: 0;
      cursor: pointer;
      &:checked {
          z-index: 2;
          ~i.toggle.icon-plus {
              display: none;
          }
          ~i.toggle.icon-minus {
              display: block;
          }
      }
      &:not(:checked) {
          ~i.toggle.icon-minus {
              display: none;
          }
          ~i.toggle.icon-plus {
              display: block;
          }
          ~label.option input:not(:checked)~.title {
              display: none!important;
          }
      }
      &:disabled {
          cursor: no-drop;
      }
  }
  & label>span.placeholder {
      position: relative;
      z-index: 0;
      display: inline-block;
      width: 100%;
      color: #999;
      border-top: 0px;
  }
  label.option {
      display: block;
      overflow: hidden;
      z-index: 1;
      width: 100%;
      transition: all 1s ease-out;
      span.title {
          position: relative;
          z-index: 2;
          transition: background .3s ease-out;
          i.icon {
              padding-right: 8px;
              color: rgba(146, 168, 209, 1);
          }
          &:hover {
              color: #fff;
              background: rgba(146, 168, 209, .5);
              box-shadow: inset 0px 1px 0px rgba(0, 0, 0, .1);
          }
      }
      input {
          display: none;
          &:checked~span.title {
              position: absolute;
              display: block;
              z-index: 1;
              top: 0px;
              font-size: 12px;
              background: #fff;
              border-top: 0px;
              box-shadow: none;
              color: inherit;
              width: 100%;
          }
          &:disabled {
              &~span.title {
                  background: #f9f9f9!important;
                  color: #aaa;
                  &:hover {
                      color: #aaa;
                      background: none;
                      cursor: no-drop;
                  }
              }
          }
      }
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;;AAEtB;;;;AAIA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+GAAkG;AACpG;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;EAChD;MACI,kBAAkB;MAClB,UAAU;MACV,YAAY;MACZ,UAAU;MACV;EACJ;EACA;;MAEI,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,kCAAkC;MAClC,wCAAwC;MACxC,eAAe;EACnB;EACA;MACI,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,UAAU;MACV,WAAW;MACX,YAAY;MACZ,cAAc;MACd,UAAU;MACV,eAAe;MACf;UACI;cACI,aAAa;UACjB;UACA;cACI,cAAc;UAClB;UACA;cACI,uBAAuB;UAC3B;MACJ;MACA;UACI,UAAU;UACV;cACI;kBACI,aAAa;cACjB;UACJ;UACA;cACI,aAAa;UACjB;UACA;cACI,cAAc;UAClB;MACJ;MACA;UACI,eAAe;MACnB;EACJ;EACA;MACI,kBAAkB;MAClB,UAAU;MACV,qBAAqB;MACrB,WAAW;MACX,WAAW;MACX,eAAe;EACnB;EACA;MACI,cAAc;MACd,gBAAgB;MAChB,UAAU;MACV,WAAW;MACX,2BAA2B;MAC3B;UACI,kBAAkB;UAClB,UAAU;UACV,mCAAmC;UACnC;cACI,kBAAkB;cAClB,6BAA6B;UACjC;UACA;cACI,WAAW;cACX,mCAAmC;cACnC,+CAA+C;UACnD;MACJ;MACA;UACI,aAAa;UACb;cACI,kBAAkB;cAClB,cAAc;cACd,UAAU;cACV,QAAQ;cACR,eAAe;cACf,gBAAgB;cAChB,eAAe;cACf,gBAAgB;cAChB,cAAc;cACd,WAAW;UACf;UACA;cACI;kBACI,6BAA6B;kBAC7B,WAAW;kBACX;sBACI,WAAW;sBACX,gBAAgB;sBAChB,eAAe;kBACnB;cACJ;UACJ;MACJ;EACJ;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;EAChD;MACI,kBAAkB;MAClB,UAAU;MACV,YAAY;MACZ,UAAU;MACV;EACJ;EACA;;MAEI,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,kCAAkC;MAClC,wCAAwC;MACxC,eAAe;EACnB;EACA;MACI,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,UAAU;MACV,WAAW;MACX,YAAY;MACZ,cAAc;MACd,UAAU;MACV,eAAe;MACf;UACI,UAAU;UACV;cACI,aAAa;UACjB;UACA;cACI,cAAc;UAClB;MACJ;MACA;UACI;cACI,aAAa;UACjB;UACA;cACI,cAAc;UAClB;UACA;cACI,uBAAuB;UAC3B;MACJ;MACA;UACI,eAAe;MACnB;EACJ;EACA;MACI,kBAAkB;MAClB,UAAU;MACV,qBAAqB;MACrB,WAAW;MACX,WAAW;MACX,eAAe;EACnB;EACA;MACI,cAAc;MACd,gBAAgB;MAChB,UAAU;MACV,WAAW;MACX,2BAA2B;MAC3B;UACI,kBAAkB;UAClB,UAAU;UACV,mCAAmC;UACnC;cACI,kBAAkB;cAClB,6BAA6B;UACjC;UACA;cACI,WAAW;cACX,mCAAmC;cACnC,+CAA+C;UACnD;MACJ;MACA;UACI,aAAa;UACb;cACI,kBAAkB;cAClB,cAAc;cACd,UAAU;cACV,QAAQ;cACR,eAAe;cACf,gBAAgB;cAChB,eAAe;cACf,gBAAgB;cAChB,cAAc;cACd,WAAW;UACf;UACA;cACI;kBACI,6BAA6B;kBAC7B,WAAW;kBACX;sBACI,WAAW;sBACX,gBAAgB;sBAChB,eAAe;kBACnB;cACJ;UACJ;MACJ;EACJ;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n:root {\n  --Fond-clair: '#F9F2F2';\n  --main-bg-color: brown;\n}\n\nselect {\n  /* appearance: none; */\n  background-color: transparent;\n  border: none;\n  padding: 1em;\n  margin: 0;\n  width: 100%;\n  font-family: inherit;\n  font-size: inherit;\n  cursor:auto;\n  line-height: inherit;\n  \n}\n\n\n\n.App {\n  text-align: center;\n}\n\nhtml, body {\n  height: 100svh;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.active {\n  color: red;\n}\n\n.inactive {\n  color: #444;\n}\n\n.bg {\n  background: var(--Fond-clair, url('./assets/img/bg.png') lightgray 50% / cover no-repeat, #F9F2F2);\n}\n\n.img-crop {\n  overflow: hidden;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.rotate {\n  transform: rotate(180deg);\n}\n\n.onHover {\n  cursor: pointer;\n  &:hover {\n    box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 6px;\n  }\n}\n\n.onHoverBorder {\n  border: 1px solid #C3645E;\n}\n\n.fadeIn {\n  animation: 0.5s fadeIn forwards;\n  height: -webkit-fill-available;\n}\n\n.fadeOut {\n  /* animation: 0.0001s fadeOut forwards; */\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.select {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: auto;\n  width: 330px;\n  height: 100%;\n  border-bottom: 0px;\n  border-radius: 3px;\n  font-size: 12px;\n  box-shadow: 0px 1em 2em -1.5em rgba(0, 0, 0, .5);\n  >i.toggle {\n      position: absolute;\n      z-index: 4;\n      right: 1.5em;\n      top: 1.6em;\n      color: #ccc\n  }\n  .title,\n  .placeholder {\n      position: relative;\n      display: block;\n      width: 100%;\n      height: 100%;\n      padding: 1.5em 2em;\n      background: rgba(255, 255, 255, 1);\n      border-top: 1px solid rgba(0, 0, 0, .05);\n      cursor: pointer;\n  }\n  &>input {\n      position: absolute;\n      left: 0px;\n      top: 0px;\n      z-index: 1;\n      width: 100%;\n      height: 100%;\n      display: block;\n      opacity: 0;\n      cursor: pointer;\n      &:checked {\n          ~i.toggle.icon-arrow-down {\n              display: none;\n          }\n          ~i.toggle.icon-arrow-up {\n              display: block;\n          }\n          div.options label.option .title {\n              display: none!important;\n          }\n      }\n      &:not(:checked) {\n          z-index: 4;\n          ~label.option {\n              >span.title {\n                  display: none;\n              }\n          }\n          ~i.toggle.icon-arrow-up {\n              display: none;\n          }\n          ~i.toggle.icon-arrow-down {\n              display: block;\n          }\n      }\n      &:disabled {\n          cursor: no-drop;\n      }\n  }\n  &>span.placeholder {\n      position: relative;\n      z-index: 0;\n      display: inline-block;\n      width: 100%;\n      color: #999;\n      border-top: 0px;\n  }\n  label.option {\n      display: block;\n      overflow: hidden;\n      z-index: 1;\n      width: 100%;\n      transition: all 1s ease-out;\n      span.title {\n          position: relative;\n          z-index: 2;\n          transition: background .3s ease-out;\n          i.icon {\n              padding-right: 8px;\n              color: rgba(146, 168, 209, 1);\n          }\n          &:hover {\n              color: #fff;\n              background: rgba(255, 255, 255, .3);\n              box-shadow: inset 0px 1px 0px rgba(0, 0, 0, .1);\n          }\n      }\n      input {\n          display: none;\n          &:checked~span.title {\n              position: absolute;\n              display: block;\n              z-index: 3;\n              top: 0px;\n              font-size: 12px;\n              background: #fff;\n              border-top: 0px;\n              box-shadow: none;\n              color: inherit;\n              width: 100%;\n          }\n          &:disabled {\n              &~span.title {\n                  background: #f9f9f9!important;\n                  color: #aaa;\n                  &:hover {\n                      color: #aaa;\n                      background: none;\n                      cursor: no-drop;\n                  }\n              }\n          }\n      }\n  }\n}\n\n.select2 {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: auto;\n  width: 330px;\n  height: 100%;\n  border-bottom: 0px;\n  border-radius: 3px;\n  font-size: 12px;\n  box-shadow: 0px 1em 2em -1.5em rgba(0, 0, 0, .5);\n  i.toggle {\n      position: absolute;\n      z-index: 4;\n      right: 1.5em;\n      top: 1.6em;\n      color: #ccc\n  }\n  .title,\n  .placeholder {\n      position: relative;\n      display: block;\n      width: 100%;\n      height: 100%;\n      padding: 1.5em 2em;\n      background: rgba(255, 255, 255, 1);\n      border-top: 1px solid rgba(0, 0, 0, .05);\n      cursor: pointer;\n  }\n  &>label>input {\n      position: absolute;\n      left: 0px;\n      top: 0px;\n      z-index: 2;\n      width: 100%;\n      height: 100%;\n      display: block;\n      opacity: 0;\n      cursor: pointer;\n      &:checked {\n          z-index: 2;\n          ~i.toggle.icon-plus {\n              display: none;\n          }\n          ~i.toggle.icon-minus {\n              display: block;\n          }\n      }\n      &:not(:checked) {\n          ~i.toggle.icon-minus {\n              display: none;\n          }\n          ~i.toggle.icon-plus {\n              display: block;\n          }\n          ~label.option input:not(:checked)~.title {\n              display: none!important;\n          }\n      }\n      &:disabled {\n          cursor: no-drop;\n      }\n  }\n  & label>span.placeholder {\n      position: relative;\n      z-index: 0;\n      display: inline-block;\n      width: 100%;\n      color: #999;\n      border-top: 0px;\n  }\n  label.option {\n      display: block;\n      overflow: hidden;\n      z-index: 1;\n      width: 100%;\n      transition: all 1s ease-out;\n      span.title {\n          position: relative;\n          z-index: 2;\n          transition: background .3s ease-out;\n          i.icon {\n              padding-right: 8px;\n              color: rgba(146, 168, 209, 1);\n          }\n          &:hover {\n              color: #fff;\n              background: rgba(146, 168, 209, .5);\n              box-shadow: inset 0px 1px 0px rgba(0, 0, 0, .1);\n          }\n      }\n      input {\n          display: none;\n          &:checked~span.title {\n              position: absolute;\n              display: block;\n              z-index: 1;\n              top: 0px;\n              font-size: 12px;\n              background: #fff;\n              border-top: 0px;\n              box-shadow: none;\n              color: inherit;\n              width: 100%;\n          }\n          &:disabled {\n              &~span.title {\n                  background: #f9f9f9!important;\n                  color: #aaa;\n                  &:hover {\n                      color: #aaa;\n                      background: none;\n                      cursor: no-drop;\n                  }\n              }\n          }\n      }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
